import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 5v8h-8","key":"svg-0"}],["path",{"d":"M17 9v8h-8","key":"svg-1"}]]

const IconChevronsDownRight = createReactComponent('outline', 'chevrons-down-right', 'ChevronsDownRight', __iconNode);

export default IconChevronsDownRight;